<h3 mat-dialog-title class="p-2 m-0 text-center">Mesure à copier <br />(Plage horaire, Sécurité, Météo)</h3>
<div mat-dialog-content class="p-3 m-0">

    <div class="row">
        <mat-form-field class="col">
            <mat-label>zone à copier</mat-label>
            <mat-select [(ngModel)]="SelectedMeasure" required>
                @for (m of AvailableMeasure; track m) {
                <mat-option [value]="m">
                    <span>{{m.MeasureReferenceName}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    @for (ph of SelectedMeasure?.Cassette?.PlageHoraireList; track ph) {
    <div class="row">
        <span class="col text-center">{{ph.Debut.toLocaleString(undefined, { day: 'numeric', month: 'numeric', hour: 'numeric', minute: 'numeric' })}}</span>
        <span class="col text-center">{{ph.Fin.toLocaleString(undefined, { day: 'numeric', month: 'numeric', hour: 'numeric', minute: 'numeric' })}}</span>
        <mat-divider></mat-divider>
    </div>
    }

    @if (SelectedMeasure) {
    <div class="row my-3">
        <div class="col-6">Exposition Climatique </div>
        <div class="col-6"> {{getExpositionLabel(SelectedMeasure.ZoneSamplingCondition.ExpositionClimatique)}}</div>
        <mat-divider></mat-divider>
        <div class="col-6">Hygrométrie </div>
        <div class="col-6">{{SelectedMeasure.ZoneSamplingCondition.Hygrometrie}}</div>
        <mat-divider></mat-divider>
        <div class="col-6">Météo </div>
        <div class="col-6">{{getMeteoLabel(SelectedMeasure.ZoneSamplingCondition.Meteo!)}}</div>
        <mat-divider></mat-divider>
        <div class="col-6">Vitesse Vent</div>
        <div class="col-6">{{SelectedMeasure.ZoneSamplingCondition.VitesseVent}}</div>
        <mat-divider></mat-divider>
    </div>
    }

    @if (SelectedMeasure && SelectedMeasure.IsDepose) {
    <div class="row ">
        <div class="col-6">Durée Exposition </div>
        <div class="col-6">{{SelectedMeasure.DeposeSecurite.DureeExposition}}</div>
        <mat-divider></mat-divider>
        <div class="col-6">Entrée Zone </div>
        <div class="col-6">{{getEntreZoneLabel(SelectedMeasure.DeposeSecurite.EntreeZone)}}</div>
        <mat-divider></mat-divider>
        <div class="col-6">EPI </div>
        <div class="col-6">{{getEPILabel(SelectedMeasure.DeposeSecurite.Epi)}}</div>
    </div>
    }

    @if (SelectedMeasure && !SelectedMeasure.IsDepose) {
    <div class="row">
        <div class="col-6">Durée Exposition </div>
        <div class="col-6">{{SelectedMeasure.PoseSecurite.DureeExposition}}</div>
        <mat-divider></mat-divider>
        <div class="col-6">Entrée Zone </div>
        <div class="col-6">{{getEntreZoneLabel(SelectedMeasure.PoseSecurite.EntreeZone)}}</div>
        <mat-divider></mat-divider>
        <div class="col-6">EPI </div>
        <div class="col-6">{{getEPILabel(SelectedMeasure.PoseSecurite.Epi)}}</div>
    </div>
    }

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!canSave()">
            Valider
        </button>
    </div>
</div>